import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, TitleWrapper } from './style';
import MainFont from '../../typography/mainFont';
import { useTranslation } from 'react-i18next';
import SelectLeadType from './SelectLeadType';
import CreateLeadB2B from './CreateLeadB2B';
import CreateLeadCSV from './CreateLeadCSV';
import CreateLeadB2C from './CreateLeadB2C';
import { LeadHistory } from '../index';
import PropTypes from 'prop-types';
import { SET_SHOW_HISTORY_TAB } from '../../../redux/slices/lead';

const CreateLead = ({ callbackOnclose, showHistoryTab, setShowHistoryTab }) => {
  const { t } = useTranslation();
  const [showAddNewLead, setShowAddNewLead] = useState(true);
  const [leadType, setLeadType] = useState(' b2b');

  useEffect(() => {
    if (showHistoryTab) {
      setShowAddNewLead(false);
      setShowHistoryTab(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showHistoryTab]);

  const loadCreationStep = () => {
    switch (leadType) {
      case 'b2b':
        return (
          <CreateLeadB2B
            resetLeadType={() => setLeadType(null)}
            leadType={leadType}
            callbackOnclose={callbackOnclose}
          />
        );
      case 'b2c':
        return (
          <CreateLeadB2C
            resetLeadType={() => setLeadType(null)}
            leadType={leadType}
            callbackOnclose={callbackOnclose}
          />
        );
      case 'csv':
        return (
          <CreateLeadCSV
            resetLeadType={() => {
              setLeadType(null);
            }}
          />
        );
      default:
        return <SelectLeadType setLeadType={setLeadType} />;
    }
  };

  return (
    <>
      <>
        <TitleWrapper>
          <Box
            highlight={showAddNewLead}
            onClick={() => setShowAddNewLead(true)}
          >
            <MainFont type={showAddNewLead ? 'highlightText' : '1'}>
              {t('add_new_lead')}
            </MainFont>
          </Box>
          <Box
            highlight={!showAddNewLead}
            onClick={() => setShowAddNewLead(false)}
          >
            <MainFont type={!showAddNewLead ? 'highlightText' : '1'}>
              {t('history')}
            </MainFont>
          </Box>
        </TitleWrapper>
        {showAddNewLead ? loadCreationStep() : <LeadHistory />}
      </>
    </>
  );
};

CreateLead.propTypes = {
  showHistoryTab: PropTypes.bool,
  callbackOnclose: PropTypes.func,
  setShowHistoryTab: PropTypes.func
};

export default connect(
  state => ({ showHistoryTab: state?.lead?.showHistoryTab }),
  dispatch => ({
    setShowHistoryTab: payload => dispatch(SET_SHOW_HISTORY_TAB(payload))
  })
)(CreateLead);
